/**
 * Maps a reward's item name to its in-game icon.
 *
 * Reward names are free text typed into the admin form, so matching is
 * case-insensitive and tolerant of plurals and stray whitespace. Anything
 * unrecognised renders without an icon rather than a broken image.
 */

const ICONS: Record<string, string> = {
  glimmer: '/icons/glimmer.webp',
  credits: '/icons/credits.webp',
  'growth flower': '/icons/growth-flower.webp',
  aniipod: '/icons/aniipod.webp',
  'aniipod pro': '/icons/aniipod-pro.webp',
  'aniipod ultra': '/icons/aniipod-ultra.webp',
};

export function iconFor(item: string): string | null {
  const key = item.trim().toLowerCase().replace(/\s+/g, ' ').replace(/s$/, '');
  return ICONS[key] ?? ICONS[`${key}s`] ?? ICONS[item.trim().toLowerCase()] ?? null;
}
